import { gql } from 'apollo-angular';

export const CREATE_DECLARANT_RATE = gql`
  mutation createDeclarantRate(
    $company: String!
    $input: CreateDeclarantRateInput!
  ) {
    createDeclarantRate(company: $company, input: $input) {
      id
      id_declarant
      id_type
      value
      uvt
    }
  }
`;

export const UPDATE_DECLARANT_RATE = gql`
  mutation updateDeclarantRate(
    $company: String!
    $input: UpdateDeclarantRateInput!
  ) {
    updateDeclarantRate(company: $company, input: $input) {
      id
      id_declarant
      id_type
      value
      uvt
    }
  }
`;
